/*
 * Copyright (c) Outright Mental. (https://outrightmental.com) All Rights Reserved.
 */

// vendor
import 'react-redux-toastr/src/styles/index.scss'
import React from 'react'
import ReduxToastr, {reducer as toastrReducer} from "react-redux-toastr";
import {Provider} from "react-redux";
// app
import './App.scss'
import store from "./engine";
import {configureStore} from "@reduxjs/toolkit";
import GameView from "./view/GameView";


const toastrStore = configureStore({
  reducer:
    {
      toastr: toastrReducer,
    }
});

/**
 App
 */
export default function App() {
  return (
    <div id="app">
      <Provider store={toastrStore}>
        <ReduxToastr
          position="bottom-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          closeOnToastrClick/>
      </Provider>
      <Provider store={store}>
        <GameView/>
      </Provider>
    </div>
  );
}
